import { ModelType } from '@App/app/entities/models/model.model';

export interface ModelTypeParam {
  title: string;
  formControlName: string;
  inputType?: string;
  isRadCenterInput?: boolean;
}

export interface ModelTypeConfig {
  subTypeName: string;
  modelTypes: ModelType[];
  params: ModelTypeParam[];
  types: Record<string, string>;
}

export const totalAreaInput = (): ModelTypeParam => {
  return {
    title: 'Total area',
    formControlName: 'totalArea',
    inputType: 'number',
  };
};
